import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  BaseSiteService,
  getLastValueSync,
  GlobalMessageService,
  RoutingService,
} from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { first, Observable } from 'rxjs';
import { CustomRegistrationService } from 'src/app/custom-user-registration/custom-registration.service';
import { AccountInformationComponent } from 'src/app/custom-user-registration/user-registration/account-information/account-information.component';
import { NonBuyingPhysicianService } from '../../services';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-non-buying-physician-account-information',
  templateUrl: './non-buying-physician-account-information.component.html',
  styleUrls: ['./non-buying-physician-account-information.component.scss'],
})
export class NonBuyingPhysicianAccountInformationComponent
  extends AccountInformationComponent
  implements OnInit
{
  constructor(
    protected accountRegService: CustomRegistrationService,
    protected cdr: ChangeDetectorRef,
    protected globalMessage: GlobalMessageService,
    protected router: RoutingService,
    protected user: UserAccountFacade,
    protected baseSiteService: BaseSiteService,
    protected nonBuyingPhysicianService: NonBuyingPhysicianService,
    protected activatedRoute: ActivatedRoute
  ) {
    super(
      accountRegService,
      cdr,
      globalMessage,
      router,
      user,
      baseSiteService,
      activatedRoute
    );
  }
  accountInfoForm: FormGroup;
  roles$: Observable<string[]> = this.accountRegService.getRoleTypes();

  ngOnInit(): void {
    this.loadRoles();
    this.accountInfoForm = this.buildAccountInfoForm();
  }

  loadRoles(): void {
    this.accountRegService
      .getRoleTypes()
      .pipe(first())
      .subscribe((roles) => {
        if (roles) {
          this.roles = roles;
          this.cdr.detectChanges();
        }
      });
  }

  buildAccountInfoForm(): FormGroup {
    return new FormGroup({
      rolesFlag: new FormControl('default', [Validators.required]),
      role: new FormControl(null),
      email: new FormControl('', [
        Validators.required,
        Validators.pattern(this.emailRegexExp),
      ]),
      recaptchaReactive: new FormControl('', [
        getLastValueSync(this.isCaptchaEnabled$)
          ? Validators.required
          : Validators.nullValidator,
      ]),
    });
  }

  resetMessages(): void {
    this.errorMsg = false;
    this.infoMsg = false;
  }

  validateIndirectAccountInfo() {
    this.resetMessages();
    this.accountInfoSub = this.nonBuyingPhysicianService
      .verifyNbpAccount(
        this.accountInfoForm.get('recaptchaReactive').value,
        this.accountInfoForm.value
      )
      .subscribe({
        next: (res) => {
          this.handleExistingUser(res);
        },
        error: (error) => {
          if (error) {
            this.accountInfoForm.patchValue({ recaptchaReactive: null });
            this.accountErrors(error);
            this.invalidFormError();
          }
        },
      });
  }

  validateIndirectAccountInAkamai() {
    if (this.accountInfoForm.valid) {
      const isRegisteredAkamaiUser = { registeredAkamaiUser: true };
      const formvalue = {
        ...this.accountInfoForm.value,
        ...isRegisteredAkamaiUser,
        ...this.validatedUserName,
      };
      this.accountInfoSub = this.nonBuyingPhysicianService
        .validateAccount(formvalue)
        .subscribe({
          next: (res) => {
            this.errorMsg = false;
            const accountInfo = {
              header: 'userInformation',
              form: this.accountInfoForm,
              akamaiRegistered: {
                registeredAkamaiUser: true,
                uuid: res.uuid,
                ...this.validatedUserName,
              },
            };
            this.accountRegService.sectionChange.next(accountInfo);
          },
          error: (error) => {
            if (error) {
              this.checkIndirectErrorsFromAkamai(error);
              this.invalidFormError();
            }
          },
        });
    } else {
      this.invalidFormError();
    }
  }

  generateErrorMessages(message: any): void {
    super.generateErrorMessages(message);
    if (message !== 'resetPasswordEmailSentMsg') {
      this.bannerMessage =
        'non-buying-physician.registration.errors.validation';
    }
  }

  handleExistingUser(res) {
    if (res.existingUserCheck) {
      this.validatedUserName = { userName: res?.userName };
      this.accountInfoForm.addControl(
        'password',
        new FormControl('', Validators.required)
      );
      this.isIndirectB2BUnitValidated = true;
      this.infoMsg = true;
    }
    if (!res.existingUserCheck) {
      this.errorMsg = true;
    }
    this.cdr.detectChanges();
  }
}
